/* eslint-disable arrow-body-style */
import { useEffect, useState } from 'react';
import { breakpoints, useWindowSize } from '@edx/paragon';
import PropTypes from 'prop-types';

import AiTutorDesktop from './AiTutorDesktop';
import AiTutorMobile from './AiTutorMobile';
import AiReminderModal from './AiReminderModal';
import { timeToShowAiReminderModal } from './AiReminderModal/constants';
import useAiTutor from './hooks';
import './index.scss';

const AI_REMINDER_MODAL_LAST_SHOWN_KEY = 'aiReminderModalLastShown';

const AiTutor = ({ courseId }) => {
  const [isClient, setIsClient] = useState(false);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isFirstShow, setIsFirstShow] = useState(false);
  const [pendingMessage, setPendingMessage] = useState('');

  const windowSize = useWindowSize();
  const isMobileView = windowSize.width < breakpoints.small.minWidth;
  const { isEnabled, isLoading } = useAiTutor(courseId);

  useEffect(() => {
    setIsClient(true);
    const lastShown = localStorage.getItem(AI_REMINDER_MODAL_LAST_SHOWN_KEY);
    const shouldShow = !lastShown || Date.now() - Number(lastShown) >= timeToShowAiReminderModal;
    if (shouldShow) {
      setIsFirstShow(!lastShown);
      setIsReminderModalOpen(true);
    }
  }, []);

  if (!isClient) {
    return null;
  }

  if (isLoading || !isEnabled) {
    return null;
  }

  const handleModalClose = () => {
    localStorage.setItem(AI_REMINDER_MODAL_LAST_SHOWN_KEY, String(Date.now()));
    setIsReminderModalOpen(false);
  };

  const handleModalSend = text => {
    setPendingMessage(text);
    handleModalClose();
  };

  return (
    <>
      <AiReminderModal
        isOpen={isReminderModalOpen}
        isFirstShow={isFirstShow}
        onClose={handleModalClose}
        onSendMessage={handleModalSend}
      />
      {isMobileView ? (
        <AiTutorMobile
          courseId={courseId}
          pendingMessage={pendingMessage}
          onPendingMessageConsumed={() => setPendingMessage('')}
        />
      ) : (
        <AiTutorDesktop
          courseId={courseId}
          pendingMessage={pendingMessage}
          onPendingMessageConsumed={() => setPendingMessage('')}
        />
      )}
    </>
  );
};

AiTutor.propTypes = {
  courseId: PropTypes.string.isRequired,
};

export default AiTutor;
